var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// ./node_modules/is-regex/node_modules/function-bind/index.js
// module id = 1106
// module chunks = 58